import SpecDetailDragAndDropContainer from "./SpecDetailDragAndDropContainer";
export default SpecDetailDragAndDropContainer;
